import {
    Component,
    EventEmitter,
    forwardRef,
    HostBinding,
    Injector,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ImageService} from "@fedeltapointofsale/data-client";
import {UncachedImageData} from "../../../../shared/image/uncached-image.data";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ImageEditControlComponent),
    multi: true
};

@Component({
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "wbo-image-edit-control",
    templateUrl: "./image-edit-control.component.html",
    styleUrls: ["./image-edit-control.component.scss"]
})
export class ImageEditControlComponent extends AbstractEditControlComponent implements OnChanges {
    @Input() imageComponent: UncachedImageData;
    @Input() allowSvg: boolean = false;
    @Input() showImage: boolean = true;
    @Input() maxImageSize: number = 256000;
    @Input() showOpacitySlider: boolean = false;
    @Input() placeholderImage: string;
    @Input() placeholderImageComponent: UncachedImageData;
    @Output() imageOpacityChange: EventEmitter<number> = new EventEmitter<number>();

    @HostBinding("class.opacityOnly") get opacityOnly(): boolean {
        return this.showOpacitySlider && !this.showImage;
    };

    private _imageOpacity: number = 1.0;
    private imageService: ImageService;

    constructor(injector: Injector) {
        super(injector);
        this.imageService = injector.get(ImageService, null);
    }

    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes["imageComponent"] || changes["placeholderImageComponent"]) {
            this.lazyLoadImages();
        }
    }

    get imageOpacity(): number {
        return this._imageOpacity;
    }

    @Input()
    set imageOpacity(imageOpacity: number) {
        if (imageOpacity != this._imageOpacity) {
            this._imageOpacity = imageOpacity;
            this.imageOpacityChange.emit(imageOpacity);
        }
    }

    private async lazyLoadImages(): Promise<void> {
        if (this.imageComponent && this.imageComponent.id && !this.imageComponent.image) {
            this.value = await this.imageService.lazyLoadImage(this.imageComponent);
            this.changeDetectorRef.detectChanges();
        }
        if (this.placeholderImageComponent && this.placeholderImageComponent.id && !this.placeholderImageComponent.image) {
            this.placeholderImage = await this.imageService.lazyLoadImage(this.placeholderImageComponent);
            this.changeDetectorRef.detectChanges();
        }
    }
}
